<template>
    <div style="height:90%">
        <modify-ttl v-if="openModifyTTL" :filesInfo="[selectedFileVersionInfo]" context='bins' @close="openModifyTTL = false"></modify-ttl>
        <div>
            <create-placeholder v-if="openCreatePlaceholderDialog" :fileInfo="fileInfo" @close="openCreatePlaceholderDialog=false"></create-placeholder>
          </div>
        <div :style="disableUpload?'padding-top: 12px;':''" style="display: flex;flex-direction: column;height:100%">
            <div v-if="!lockRestrictedAction('Upload') && isEnabled('Upload') && !disableUpload && checkIfMarkedForDelete()"  class="primary-btn-style mr-3 pt-2" style="float: inline-end;">
                <button v-if='Object.keys(placeholderInfo).length == 0'  v-on:click="openCreatePlaceholderDialog = true" class="btn btn-outline-secondary m-2" style="border: 1px solid #585858;">{{$t('Create Placeholder')}}</button>
                <button v-if='Object.keys(placeholderInfo).length == 0' class="btn btn-outline-primary m-2" style="position:relative">
                  {{$t('Upload New Version')}}
                    <div style="position: absolute;top: 1%;inset-inline-start:0%;opacity: 0;height:100%;width:100%">
                        <input 
                            style="height:100%;width:100%"
                            type="file"
                            id="file"
                            ref="uploadFile"
                            v-on:click="resetImageUploader()"
                            v-on:change="getUploadDetailsThroughPath($event)"
                            />
                    </div>
                  </button>
            </div>
            <div class="version-info-display">
                <div v-if='Object.keys(placeholderInfo).length > 0' style="padding: 5px;">
                  <div class="version-placeholder-tag">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#000" class="bi bi-bounding-box" viewBox="0 0 16 16" style="margin: 3px;">
                      <path d="M5 2V0H0v5h2v6H0v5h5v-2h6v2h5v-5h-2V5h2V0h-5v2H5zm6 1v2h2v6h-2v2H5v-2H3V5h2V3h6zm1-2h3v3h-3V1zm3 11v3h-3v-3h3zM4 15H1v-3h3v3zM1 4V1h3v3H1z"/>
                    </svg>
                    {{$t('Placeholder')}}</div>
                  <ul style="margin:18px;" class="placeholder-file-name">
                    <li style="width:100%">
                        <div class="key-style" style="width:28%;display: flex;align-items: center;justify-content: end;">{{$t('Placeholder filename')}}</div>
                        <div class="value-style">
                          <div>{{placeholderInfo.placeholder_id?placeholderInfo.placeholder_id:''}}</div>
                          <svg v-if="!isCopied" v-on:click="copyTheText(placeholderInfo.placeholder_id)" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#9c9c9c" class="bi bi-files mr-3 hightlight-icon" viewBox="0 0 16 16" style="position: absolute;top: 5px;inset-inline-end :10px;cursor: pointer;">
                            <path d="M13 0H6a2 2 0 0 0-2 2 2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2 2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm0 13V4a2 2 0 0 0-2-2H5a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1zM3 4a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4z"/>
                            <title>{{$t('Copy')}}</title>
                          </svg>
                          <svg v-if="isCopied" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#9c9c9c" class="bi bi-check mr-3" viewBox="0 0 16 16" style="position: absolute;top: 5px;inset-inline-end :10px;cursor: pointer;">
                            <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z"/>
                          </svg>
                          <div class="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true" style="position:absolute;top:5px;inset-inline-end:5px;cursor: pointer;">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#9c9c9c" class="bi bi-three-dots-vertical hightlight-icon" viewBox="0 0 16 16">
                              <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>
                            </svg>
                            <div class="dropdown-menu dropdown-menu-md-right p-0" aria-labelledby="bd-versions" style="inset-inline-start:0px;">
                              <a v-on:click="deleteVersionPlaceholder()" class="dropdown-item p-2">{{$t('Delete')}}</a>
                            </div>
                          </div>
                        </div>
                    </li>
                    <li>
                      <div class="key-style" style="width:29%;display: flex;align-items: center;justify-content: end;">{{$t('Created datetime')}}</div>
                      <div class="value-style mb-0">
                        <div>{{getDateAndTimeInConfiguredFormat(placeholderInfo.created_datetime)}}</div>
                      </div>
                    </li>
                  </ul>
                </div>
                <div v-if="uploadedFilesList.length" class="upload-progress-bar">
                    <div class="d-flex mb-2" v-for="files in uploadedFilesList" :key="files.fileUID">
                        <div class="file-name-with-progress-bar-wrapper" :id="files.fileUID" :file-data="files">
                          <div class="file-name-wrapper">
                              <div class="file-name-display" :title="files.fileName">{{files.fileName}}</div><div>
                                <span class="file-size-display">{{ humaniseSize(files.fileSize)}}</span>
                                <span class="file-size-display">{{"  |  " + getDateAndTimeInConfiguredFormat(files.createdTime)}}</span>
                                </div>
                                <div class="progress-bar-wrapper" v-if="files.status == 'INPROGRESS'">
                                  <div class="progress-percentage-display">{{Math.round(files.uploadPercentage) + "%"}}</div>
                                  <div class="progress">
                                              <div class="progress-bar" role="progressbar" :style="{width:files.uploadPercentage + '%'}" :aria-valuenow="files.uploadPercentage" aria-valuemin="0" aria-valuemax="100"></div>
                                  </div>
                                  <div class="progress-speed-display">
                                      {{files.bandwidth.bandwidth}} {{files.bandwidth.unit}}
                                  </div>    
                              </div>
                          </div>
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" v-if="files.status == 'COMPLETED'" fill="green" class="bi bi-check-circle-fill mt-1" viewBox="0 0 16 16">
                              <title>COMPLETED</title>
                              <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
                          </svg>
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#b43131" v-if="files.status == 'FAILED'" class="bi bi-exclamation-circle-fill mt-1" viewBox="0 0 16 16">
                              <title>FAILED</title>
                              <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4zm.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"/>
                          </svg>
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#dd8518" v-if="files.status == 'INITIALIZING'" class="bi bi-clock-fill mt-1" viewBox="0 0 16 16">
                            <title>INITIALIZING</title>
                            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z"/>
                          </svg>
                          <!-- <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="#b43131" v-if="files.status != 'COMPLETED'" class="bi bi-x ml-2 remove-selected-file" v-on:click="discardSelectedFileFromUpload(files.fileUID,files.status)" viewBox="0 0 16 16">
                            <title>Remove File</title>
                            <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                          </svg> -->
                      </div>
                    </div>
                </div>
                <div v-if="displayNewVersionPlaceholder" class="upload-progress-bar upload-placeholder-styles">
                        {{$t('Initializing new upload')}} ...
                </div>
                <div v-for="version in versionInfo.slice().reverse()" :key="version.version_id" class="version-basic-info-wrapper">
                    
                    <div v-if="!lockRestrictedAction('Mark For Delete') && isEnabled('Mark For Delete') && !['DELETED', 'MARK FOR DELETE'].includes(version.version_state)" class="dropdown-toggle actions-on-manage-versions" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true" style="position:absolute;top:10px;inset-inline-end:5px;cursor: pointer">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#9c9c9c" class="bi bi-three-dots-vertical" viewBox="0 0 16 16">
                        <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>
                      </svg>
                      <div v-on:click.stop.prevent="deleteSelectedVersion(version)" class="dropdown-menu dropdown-menu-md-right p-0" aria-labelledby="bd-versions" style="inset-inline-start:0px;">
                        <a  class="dropdown-item p-2 delete-version">Delete Version</a>
                      </div>
                    </div>
                    <div style="display:inline-flex">
                        <div class="version-number-tag">V-{{version.version_number}}</div>
                        <div v-if="version.version_number == versionInfo[versionInfo.length - 1].version_number" class="latest-version-tag" style="padding:4px">{{$t('Latest Version')}}</div>
                        <div style="padding:4px;color:#9c9c9c">{{humaniseSize(version.size)}}</div>
                        <div style="padding:4px;color:#9c9c9c">{{getDateAndTimeInConfiguredFormat(version.created_datetime)}} </div>
                    </div>
                    <div class="row m-0 p-0 pt-1">
                        <div v-if="version.proxy_info" class="col-md-2">
                            <div v-on:click.stop.prevent="handlePreviewAction(version)" style="height: 68px; width: 114px; position: relative;align-items: center;display: inline-flex;justify-content:center;cursor:pointer">
                                <img :src="getThumbnailPath(version)" @error="replaceByDefaultImage" alt="image" draggable="false" style="height:100%;border-radius: 8px;max-width:100%"/>
                            </div>
                        </div>
                        <div class="col-md-10">
                            <ul style="background:transparent !important; border: none">
                                <li v-if="version.version_id">
                                    <div class="key-style">{{$t('Version ID')}}</div>
                                    <div class="value-style">{{version.version_id}}</div>
                                </li>
                                <li v-if="version.version_state">
                                    <div class="key-style">{{$t('Version State')}}</div>
                                    <div class="value-style">{{version.version_state}}</div>
                                </li>
                            </ul>
                            <template v-if="version.files">
                              <template v-for="fileInfo in version.files" >
                                <ul :key="fileInfo.file_uid">
                                      <li v-if="startupData.enable_reference_id_workflow && Object.keys(fileInfo).includes('reference_id') &&
                                      !['undefined',null].includes(fileInfo.reference_id) &&  fileInfo.reference_id.length > 0">
                                        <div class="key-style">{{startupData.alias &&  startupData.alias.alias_name?startupData.alias.alias_name:"Reference ID"}}</div>
                                        <div class="value-style">{{fileInfo.reference_id}}</div>
                                    </li>
                                    <li v-if="fileInfo.path">
                                        <div class="key-style">{{$t('Path')}}</div>
                                        <div class="value-style">{{fileInfo.path}}</div>
                                    </li>
                                    <li v-if="fileInfo.created_datetime">
                                        <div class="key-style">{{$t('Created On')}}</div>
                                        <div class="value-style">{{getDateAndTimeInConfiguredFormat(fileInfo.created_datetime)}}</div>
                                    </li>
                                    <li v-if="fileInfo.file_uid">
                                        <div class="key-style">{{$t('File Id')}}</div>
                                        <div class="value-style">{{fileInfo.file_uid}}</div>
                                    </li>
                                    <li v-if="fileInfo.state">
                                        <div class="key-style">{{$t('State')}}</div>
                                        <div class="value-style">{{fileInfo.state}}</div>
                                    </li>
                                    <li v-if="fileInfo.username">
                                        <div class="key-style">{{$t('Created By')}}</div>
                                        <div class="value-style">{{fileInfo.username}}</div>
                                    </li>
                                    <li v-if="fileInfo.path_label && fileInfo.path_label.length">
                                      <div class="key-style">{{$t('Path Label')}}</div>
                                      <div style="width:70%;display:flex;margin-inline-start: 8px;">
                                        <div v-for="label in fileInfo.path_label" :key="label" class="value-style tag-style" style="width:auto"><span>{{label}}</span></div>
                                      </div>
                                    </li>
                                    <li v-if="fileInfo.location && fileInfo.location.length">
                                        <div class="key-style">{{$t('Location')}}</div>
                                        <div class="value-style">
                                          <div v-for="storageClass in fileInfo.location" class="d-inline-flex" :key="storageClass">
                                            <svg v-if='storageClass == "Disk"' xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#35b2cf" class="bi bi-archive-fill" viewBox="0 0 16 16"><path d="M12.643 15C13.979 15 15 13.845 15 12.5V5H1v7.5C1 13.845 2.021 15 3.357 15h9.286zM5.5 7h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1zM.8 1a.8.8 0 0 0-.8.8V3a.8.8 0 0 0 .8.8h14.4A.8.8 0 0 0 16 3V1.8a.8.8 0 0 0-.8-.8H.8z"></path><title>Archived</title></svg>
                                            <svg v-else xmlns="http://www.w3.org/2000/svg" width="16" height="16" :fill="getColorBasedOnExpiry(fileInfo.location_info,storageClass)" class="bi bi-cloud-fill storage-type-icon" viewBox="0 0 16 16">
                                              <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/>
                                            </svg>
                                            <span style="margin-inline-start:4px">{{ storageClass }}</span>
                                          </div>
                                        </div>
                                    </li>
                                    <li v-if="(Object.keys(fileInfo).includes('ttl') &&
                                      !['undefined',null].includes(fileInfo.ttl) &&  fileInfo.ttl.length > 0)"  style="display:flex" >
                                        <div class="key-style">{{$t('Expires on')}}</div>
                                        <div class="value-style">{{getDateAndTimeInConfiguredFormat(fileInfo.ttl)}}</div>
                                    </li>
                                    <li v-if="(Object.keys(fileInfo).includes('ttk') &&
                                          !['undefined',null].includes(fileInfo.ttk) &&  fileInfo.ttk.length > 0)" style="display:flex">
                                        <div class="key-style">{{$t('Permanently expires on')}}</div>
                                        <div class="value-style">{{getDateAndTimeInConfiguredFormat(fileInfo.ttk)}}</div>
                                    </li>

                                    <li style="text-transform: capitalize;">
                                      <div class="key-style mr-2">{{$t('Locked')}}</div>
                                      <div class="value-style" v-if="'lock' in fileInfo && fileInfo.lock" style="margin-inline-start: 3px;">{{fileInfo.lock}}</div>
                                      <div class="value-style" v-else style="margin-inline-start: 3px;">False</div>
                                    </li>
                                    <div v-if="fileInfo.state && fileInfo.state != 'DELETED'" class="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true" style="position:absolute;top:10px;inset-inline-end:5px;cursor: pointer">
                                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#9c9c9c" class="bi bi-three-dots-vertical hightlight-icon" viewBox="0 0 16 16">
                                        <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>
                                      </svg>
                                      <div class="dropdown-menu dropdown-menu-md-right p-0" aria-labelledby="bd-versions" style="inset-inline-start:0px;">
                                        <a v-on:mouseover.stop.prevent="openExportSubmenu = false" v-if="fileInfo.state && ['READY','OUTDATED'].includes(fileInfo.state) && !lockRestrictedAction('Download') && isEnabled('Download')" v-on:click="handleDownloadAction(fileInfo,version)" class="dropdown-item p-2">{{$t('Download')}}</a>
                                        <a v-on:mouseover.stop.prevent="openExportSubmenu = true,fetchDeploymentBinsFromServer()" v-if="fileInfo.state && ['READY','OUTDATED'].includes(fileInfo.state) && !lockRestrictedAction('Export') && isEnabled('Export')" class="dropdown-item p-2" style="position:relative">{{$t('Export to')}}
                                            <a v-if="openExportSubmenu" class="sub-dropdown-item p-0" style="inset-inline-start :-100%;position: absolute;top: 0px;border: 1px solid #3a3a3a;background: #15181B;">
                                              <template v-for="bin in deploymentBinsList">
                                                <div v-on:click.stop.prevent="getExportEventHandler(bin,fileInfo)"  :key="bin.bin_id" class="subaction-styles">
                                                  {{ bin.bin_id}}
                                                </div>
                                              </template>
                                            </a>
                                        </a>
                                        <a v-on:mouseover.stop.prevent="openExportSubmenu = false" v-if='fileInfo.state && ["READY","OUTDATED"].includes(fileInfo.state) && !lockRestrictedAction("Mark For Delete") && isEnabled("Mark For Delete")' v-on:click="handleMarkForDeleteEvents(fileInfo,version,'Mark For Delete')" class="dropdown-item p-2 delete-version">{{$t('Mark For Delete')}}</a>
                                        <a v-on:mouseover.stop.prevent="openExportSubmenu = false" v-if='fileInfo.state && fileInfo.state == "MARK FOR DELETE" && !lockRestrictedAction("Restore") && isEnabled("Restore")' v-on:click="handleMarkForDeleteEvents(fileInfo,version,'Restore')" class="dropdown-item p-2">Restore</a>
                                        <a v-on:mouseover.stop.prevent="openExportSubmenu = false" v-if='fileInfo.state && fileInfo.state == "MARK FOR DELETE" && !lockRestrictedAction("Delete Permanently") && isEnabled("Delete Permanently")' v-on:click="handleMarkForDeleteEvents(fileInfo,version,'Delete Permanently')" class="dropdown-item p-2">{{$t('Delete Permanently')}}</a>
                                        <a v-on:mouseover.stop.prevent="openExportSubmenu = false" v-if='fileInfo.state && ["READY","OUTDATED"].includes(fileInfo.state) && !lockRestrictedAction("Modify TTL") && isEnabled("Modify TTL")' v-on:click="modifyTTLOfSelectedVersion(fileInfo,version)" class="dropdown-item p-2">{{$t('Modify TTL')}}</a>
                                        <a v-on:mouseover.stop.prevent="openExportSubmenu = false" v-if='fileInfo.state && fileInfo.state != "DELETED" && !lockRestrictedAction("GenerateProxy") && isEnabled("GenerateProxy")' v-on:click="submitGenerateProxyJob(fileInfo,version)" class="dropdown-item p-2">{{$t('Generate Proxy')}}</a>
                                      </div>
                                    </div>
                                </ul>
                              </template>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Utils from '../../components.utils.js';
import CreatePlaceholder from "./CreatePlaceholder.vue"
import {mapActions,mapMutations,mapGetters} from "vuex";
import FileUploaderToCloud from "../../plugins/fileUploadToCloud.js"
import FileUploder from "../../plugins/fileUploader.js";
import Constants from "../../components.constants.js";
import modifyTTL from "../actions/ModifyTTL.vue";
import {NotifierConstants} from '../../components.constants.js'

export default {
  props:['fileInfo','disableUpload'],
  data(){
    return{
        file_name_data:[],
        file_name_data_temp_list:[],
        uploadDetails:null,
        openCreatePlaceholderDialog:false,
        filesUploadResponse:null,
        mapFileUIdWithFileData:{},
        uploadedFilesList:[],
        mapUploadedFilesWithUuid:{},
        uploadPercentage:0,
        bandWidth:0,
        uploadedFilesListTemp:{},
        attachedFilesList:[],
        removeAttachmentCheck:false,
        mapFileDetailsWithFileUid:{},
        // eslint-disable-next-line no-useless-escape
        specialCharactersToBeAvoided: new RegExp(/[*|\/":<>\\?]/),
        versionInfo:[],
        openModifyTTL:false,
        selectedFileVersionInfo:null,
        openExportSubmenu:false,
        deploymentBinsList:[],
        displayNewVersionPlaceholder:false,
        placeholderInfo:{},
        isCopied:false,
        svgIconForStorageClass:{"Amazon S3 Glacier":'<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-cloud-fill" viewBox="0 0 16 16"><path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/></svg>',
                                    "Amazon S3 Glacier Instant Retrieval":'<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#28a745" class="bi bi-cloud-fill" viewBox="0 0 16 16"><path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/></svg>',
                                    "Amazon S3 Standard":'<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#28a745" class="bi bi-cloud-fill" viewBox="0 0 16 16"><path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/></svg>',
                                    "Disk":'<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#35b2cf" class="bi bi-archive-fill" viewBox="0 0 16 16"><path d="M12.643 15C13.979 15 15 13.845 15 12.5V5H1v7.5C1 13.845 2.021 15 3.357 15h9.286zM5.5 7h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1zM.8 1a.8.8 0 0 0-.8.8V3a.8.8 0 0 0 .8.8h14.4A.8.8 0 0 0 16 3V1.8a.8.8 0 0 0-.8-.8H.8z"></path><title>Archived</title></svg>' }
    }
  },
  components:{
    'create-placeholder':CreatePlaceholder,
    "modify-ttl": modifyTTL,
  },
  methods:{
    copyTheText(text){
      navigator.clipboard.writeText(text);
      this.isCopied = true;
      setTimeout(() => {
        this.isCopied = false;
      }, 1000);
    },
    getColorBasedOnExpiry(locationInfo,storage){
      return Utils.getAWSStorageIconColorBasedOnExpiry(locationInfo,storage)
    },
    handlePreviewAction(version){
      this.$emit("previewVersions",version)
    },
    getSvgIconForStorageClass(type){
      return this.svgIconForStorageClass[type];
    },
    isEnabled(priv) {
      return Utils.isPrivilegeEnabled(this.getLoggedInUserPrivilege, priv);
    },
    getExportEventHandler(binInfo,selectedFile){
        let payload = {
          job_name : "Export",
          element_type : "file",
          file_name : this.fileInfo.file_name,
          path : selectedFile.path,
          export_to : [binInfo.bin_id]
        }
        this.createNewJob(payload).then((data) => {
          if (data.statusCode == 200) {
            this.$toast.success(data.message);
          } else {
            this.$toast.error(data.message);
          }
        });
    },
    modifyTTLOfSelectedVersion(file){
      this.openModifyTTL = true;
      this.selectedFileVersionInfo = file;
    },
    submitGenerateProxyJob(fileInfo){
      let payload = {};
        payload.path = fileInfo.path
        payload.job_name = 'GenerateProxy';
        payload.element_type = "file";
        payload.file_uid = fileInfo.file_uid;
          this.createNewJob(payload).then((data) => {
            if (data.statusCode == 200) {
              this.$toast.success(data.message);
            } else {
              this.$toast.error(data.message);
            }
          });
    },
    async handleDownloadAction(file){
        let payload = {};
        let fileName = this.fileInfo.slug_name;
        payload.bin_id = this.fileInfo.bin_id;
        payload.path = file.path;
        payload.file_name = this.fileInfo.file_name;
        payload.element_type = "file";
        payload.job_name = "Download";
        this.initiateDownloadJob(payload).then((data) => {
          let jobIdFromResponse = data.job_id;
          let payload = {};
          payload = { job_id: "job_id=" + jobIdFromResponse };
          let downnloadUrl = `${Constants.downloadUrl}?${payload.job_id}`;
          const link = document.createElement("a");
          link.href = downnloadUrl;
          link.download = fileName;
          link.click(); 
            
          if (Utils.isAcceptedStatusCode(data.statusCode) == 200) {
            console.log("Download initiated");
          } else {
            this.$toast.error(data.message);
          }
        });
    },

    handleMarkForDeleteEvents(fileInfo,versionInfo,jobName){
      let payload = {};
        payload._id = fileInfo._id
        payload.job_name = jobName;
        payload.element_type = "file";
        payload.file_type = "file";
        payload.from_context = "bins";
        payload.size = versionInfo.size;
        payload.file_uid = fileInfo.file_uid;
        payload.parent_id_path = fileInfo.parent_id_path;
        payload.version_id = versionInfo.version_id;
        payload.asset_id = this.fileInfo.asset_id;
        payload.resource_name = fileInfo.path.split("/")[fileInfo.path.split("/").length - 1];
          this.createNewJob(payload).then((data) => {
            if (data.statusCode == 200) {
              this.$toast.success(data.message);
            } else {
              this.$toast.error(data.message);
            }
          });
    },
    deleteSelectedVersion(selectedVersionInfo){
      for(let _id in selectedVersionInfo.files){
        this.handleMarkForDeleteEvents(selectedVersionInfo.files[_id],selectedVersionInfo,'Mark For Delete')
      }
    },
    close(){
      this.$emit("close")
    },
    humaniseSize(size){
        let data = Utils.humanizeSize(size);
        return `${data["value"]} ${data["unit"]}`;
    },
    formatedDate(date){
      return Utils.getDateFormat(date);
    },
    getThumbnailPath(file) {
      return Utils.getThumbnailPathfromFileInfo(file);
    },
    replaceByDefaultImage(e){
      e.target.onerror = null
      e.target.src = Utils.getNoThumbnailImg();
    },
    resetImageUploader(){
      this.$refs.uploadFile.value = '';
    },
    checkIfMarkedForDelete(){
      if(this.versionInfo && this.versionInfo.length > 0){
        let reverseList = this.versionInfo.slice().reverse();
        if(reverseList[0].version_state == 'MARK FOR DELETE' || (reverseList[0].files && reverseList[0].files[0].state == 'MARK FOR DELETE')){
          return false
        }
      }
      return true;
    },
    lockRestrictedAction(actionName){
      return Utils.lockRestrictedAction(this.fileInfo, actionName, this.getActionListFromInMem(), this.startupData)
    },
    getUploadDetailsThroughPath(){
        this.emptyOldFiles();
        this.uploadedFilesList = [];
        let removeFileName = this.fileInfo.path.substring(0, this.fileInfo.path.lastIndexOf('/'))
        let payload = {bin_id: this.fileInfo.bin_id, folderInfo:{ path: removeFileName}}
        this.initiateUploadBySubmittingAction(payload).then((data) => {
          if(data.status == true){
            this.uploadDetails = {"responseData": data.data, "binId":payload.folderInfo.path.split("share://")[1].split("/")[0]};
            this.displayNewVersionPlaceholder = true;
            this.uploadSelectedFileToGivenPath(this.$refs.uploadFile.files)
          }else{
            this.$toast.error(data.message);
          }
        });
    },
    getFilenameWithUuid: function(fileName){ 
      let file_name = fileName;
      let lastIndexOfDot = file_name.lastIndexOf('.');
      let extension = file_name.slice(lastIndexOfDot, file_name.length);
      let namePart = file_name.slice(0,lastIndexOfDot);
      return namePart +'_'+ Utils.getUUID() + extension;
    },
    uploadSelectedFileToGivenPath(files){
        let selectedFilenames = files;
        this.file_name_data = files;
        for (let i = 0; i < selectedFilenames.length; i++) {
            this.file_name_data_temp_list.push(selectedFilenames[i])
            let payload = {};
            payload.job_name = "Upload";
            payload.element_type = "file";
            payload.group_id = this.uploadDetails.responseData.group_id;
            payload.upload_token = this.uploadDetails.responseData.upload_token;
            payload.upload_url = this.uploadDetails.responseData.upload_url;
            payload.file_name = selectedFilenames[i].name;
            payload.file_name = this.startupData.enable_reference_id_workflow?selectedFilenames[i].name:this.getFilenameWithUuid(selectedFilenames[i].name);
            payload.size = selectedFilenames[i].size;
            payload.path = this.uploadDetails.responseData.upload_path;
            payload.bin_id = this.uploadDetails.binId;
            payload.version_info = {'asset_id':this.fileInfo.asset_id?this.fileInfo.asset_id:''}
            if(Object.keys(this.uploadDetails.responseData).includes("upload_category") && Object.keys(this.uploadDetails.responseData.upload_category).length){
              if(this.uploadDetails.responseData.upload_category.parent_id_path && this.uploadDetails.responseData.upload_category._id){
                payload["catalog_id_path"] = [this.uploadDetails.responseData.upload_category.parent_id_path + "/" + this.uploadDetails.responseData.upload_category._id];
              }
            }
            if(this.specialCharactersToBeAvoided.exec(selectedFilenames[i].name) != null){
              alert('File name containing any of these <>:"|/?*\\ characters are skipped');
              continue;
            }
            this.createNewJob(payload).then((data)=>{
            if(!Utils.isAcceptedStatusCode(data.statusCode)){
                    this.$toast.error(data.message);
            }
            this.filesUploadResponse = data;
            this.mapFileUIdWithFileData[this.filesUploadResponse.data.file_uid] = this.filesUploadResponse;
            if (Utils.isAcceptedStatusCode(data.statusCode)){
                if(Object.keys(this.filesUploadResponse.data.upload_url).includes("fields")){
                    let limitUploadToCloud = this.uploadToCloudThroughProvidedUrl(selectedFilenames[i],this.filesUploadResponse.data.upload_url,this.filesUploadResponse,this.uploadDetails,this.filesUploadResponse.created_datetime,payload.file_name);
                    this.addToUploadList({"job_id":this.filesUploadResponse.job_id,"uploader": limitUploadToCloud,"uuid":this.uniqueId});
                    if(!this.mapUploadedFilesWithUuid[this.uniqueId]){
                      this.mapUploadedFilesWithUuid[this.uniqueId] = [];
                    }
                    this.mapUploadedFilesWithUuid[this.uniqueId].push(this.filesUploadResponse.data.file_uid);
                    this.startUpload();
                }else{
                    let uploader = this.handleFileUpload(selectedFilenames[i],this.uploadDetails.responseData.upload_path,this.uploadDetails.responseData.upload_token,this.filesUploadResponse.data.session_id,this.filesUploadResponse.data.file_uid,this.filesUploadResponse.job_id,this.uploadDetails.responseData.upload_url,this.filesUploadResponse.created_datetime,payload.file_name);
                    this.addToUploadList({"job_id":this.filesUploadResponse.job_id,"uploader": uploader});    
                    if(!this.mapUploadedFilesWithUuid[this.uniqueId]){
                      this.mapUploadedFilesWithUuid[this.uniqueId] = [];
                    }
                    this.mapUploadedFilesWithUuid[this.uniqueId].push(this.filesUploadResponse.data.file_uid);
                    this.startUpload()
                }
            }else{
                    this.$toast.error(data.message);
                }
            }); 
        }
    },
    handleExit(data){
      this.handleUploadExit(data.jobId)
      this.startUpload();
    },
    handleCompleted(){
      this.$emit("attachedFilesList",this.uploadedFilesList,this.attachedFilesList);
    },
    handleProgress(data){
        this.displayNewVersionPlaceholder = false;
        this.uploadedFilesList = Object.values(this.getAllJobs);
        this.uploadPercentage = data.uploadedPercentages
        this.bandWidth = data.bandwidth;
    },
    handleSuccess(data){
        this.uploadedFilesList = Object.values(this.getAllJobs);
        this.uploadPercentage = data.uploadedPercentage;
        // this.$nextTick(()=>{
        //   alert("success")
        //   this.$emit("attachedFilesList",this.uploadedFilesList,this.attachedFilesList);
        // })
    },
    handleFail(){
        this.uploadPercentage = -1
    },
    handleFileUpload(fileDetails,uploadUrl,uploadToken,sessionId,fileUID,jobId,uploadDirURL,createdTime,fileName) {
        let uploader = new FileUploder(fileDetails, uploadUrl,uploadToken, sessionId,fileUID,jobId,uploadDirURL,createdTime,fileName, false)
        uploader.on("progress", this.handleProgress);
        uploader.on("fileUploadDone", this.handleCompleted);
        uploader.on("complete", this.handleSuccess);
        uploader.on("fail", this.handleFail);
        uploader.on("exit", this.handleExit);
        return uploader;
    },
    uploadToCloudThroughProvidedUrl(file,uploadFields,filesUploadDataFromResponse,uploadResponse,createdTime,fileName){ 
        let uploader = new FileUploaderToCloud(file,uploadFields,uploadResponse,filesUploadDataFromResponse,createdTime,fileName,false);
        uploader.on("progress", this.handleProgress);
        uploader.on("complete", this.handleSuccess);
        uploader.on("fileUploadDone", this.handleCompleted);
        uploader.on("fail", this.handleFail);
        uploader.on("exit", this.handleExit);
        return uploader;
    },  
    

    //-------------------------------PLACEHOLDER--------------------------
    deleteVersionPlaceholder(){
      if (confirm(`Are you sure you want to delete placeholder?`)) {
        let  payload = {
          'placeholder_id': this.placeholderInfo._id
        }
        this.deletePlaceholder(payload).then(data => {
            if (Utils.isAcceptedStatusCode(data.statusCode)){
                this.$toast.success(data.message);
            }else{
                this.$toast.error(data.message);
            }
          })
        }
    },

    fetchDeploymentBinsFromServer(){
      let payload = {};
        payload.params = {bin_type:"deployment",status:"active",filter:JSON.stringify(["bin_type"])}
        this.getAllBinsFromServer(payload).then((data)=>{
            this.deploymentBinsList = data.bins;
      });
    },

    handleVersionUpdatedNotification(notification){
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
      if(notification.message){
        this.uploadedFilesList = [];
        this.emptyOldFiles();
        if(notification.message.asset_id == this.fileInfo.asset_id){
          this.versionInfo.push(notification.message.version_info[0]);
          this.displayNewVersionPlaceholder = false;
        }
      }
    },

    handleProxyUpdatedNotification(notification){
       let data = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
       if(data.message){
        for(let v = 0; v < this.versionInfo.length; v++){
            let vIndex = this.versionInfo[v].files.findIndex(e => e.file_uid == data.message.file_uid)
            if(vIndex > -1){
              this.$set(this.versionInfo[v], "proxy_info", data.message.proxy_info)
            }
          }
       }
    },

    handleFileUpdatedNotification(notification){
      let data = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification;
       if(data.message){
        for(let v = 0; v < this.versionInfo.length; v++){
            let vIndex = this.versionInfo[v].files.findIndex(e => e.path == data.message.path)
            if(vIndex > -1){
              Object.assign(this.versionInfo[v].files[vIndex], data.message);
            }
          }
       }
    },

    handleFileOutdatedNotification(notification){
      let data = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification;
       if(data.message){
        for(let v = 0; v < this.versionInfo.length; v++){
            let vIndex = this.versionInfo[v].files.findIndex(e => e.path == data.message.file_info.path)
            if(vIndex > -1){
              Object.assign(this.versionInfo[v].files[vIndex], data.message.file_info);
            }
          }
       }
    },

    handleVersionStateUpdatedNotification(notification){
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
      if(notification.message){
        let vIndex = this.versionInfo.findIndex(e => e.version_id == notification.message.version_id)
        if(vIndex > -1){
          this.$set(this.versionInfo[vIndex], "version_state", notification.message.version_state)
        }
      }
    },

    handleFileDeletedNotification(notification){
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
      if(notification.message){
        for(let v = 0; v < this.versionInfo.length; v++){
            let vIndex = this.versionInfo[v].files.findIndex(e => e.path == notification.message.path)
            if(vIndex > -1){
              this.$set(this.versionInfo[v].files[vIndex], "state", notification.message.state)
              console.log("vIndexvIndexvIndex",this.versionInfo[v].files[vIndex])
            }
        }
      }
    },

    handleVersionPlaceholderNotification(notification){
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
      if(notification.message && notification.message_type == 'VersionPlaceholderCreated'){
        this.placeholderInfo = notification.message;
      }
      if(notification.message && (notification.message_type == 'VersionPlaceholderDeleted'  || notification.message_type == 'VersionPlaceholderUpdated')){
        this.placeholderInfo = {};
      }
    },

    //-------------------------------PLACEHOLDER END----------------------
    // addNewVersionInfo(notification){
    //   notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification;
    //   let newFileInfo = {
    //     'files':notification.message
    //   }
    // },
    ...mapGetters("privileges",["getActionListFromInMem"]),
    ...mapActions("bins",["getAllBinsFromServer"]),
    ...mapGetters("registry",[
                                "getRegisteredBinsContextMenu", 
                                "getRegisteredBinsMoreContextMenu",
                                "getRegisteredBinsNewContextMenu",
                                "getRegisteredShareContextMenu"
                            ]),
    ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
    ...mapActions("assets", ['getVersionInfoFromServer']),
    ...mapActions("versions", ["deletePlaceholder",'deleteVersion']),
    ...mapActions("jobs", ["createNewJob"]),
    ...mapActions("upload",["initiateUploadBySubmittingAction"]),
    ...mapActions("download", ["initiateDownloadJob", "downloadFile"]),
    ...mapMutations("upload",["addToUploadList", "startUpload", "abortUpload", "handleUploadExit","setFileUploaderState","setFileUploadToCloudState","removeFailedFiles","emptyOldFiles"]),
  },
  computed:{
    startupData:{
      get(){
        return this.$store.state.startUpData.startUpDataDetails;
      }
    },
    ...mapGetters("upload",["getAllJobs"]),
    ...mapGetters("users",["getLoggedInUserPrivilege","getLoggedInUserId"]),
    // ...mapGetters("startUpData",["getStartUpDataFromInCache"]),
  },
  created(){
    this.addWSEventListener({eventname:"FILE_UPDATED", callback:this.handleFileUpdatedNotification,parent:"Version"});
    this.addWSEventListener({eventname:"FILE_OUTDATED", callback:this.handleFileOutdatedNotification,parent:"Version"});
    this.addWSEventListener({eventname:"FILE_DELETED", callback:this.handleFileDeletedNotification,parent:"Version"});
    this.addWSEventListener({eventname:["VERSION_UPDATED"],callback:this.handleVersionUpdatedNotification,parent: "Version"})
    this.addWSEventListener({eventname:["VERSION_STATE_UPDATED"],callback:this.handleVersionStateUpdatedNotification,parent: "Version"})
    this.addWSEventListener({eventname:["VersionPlaceholderCreated","VersionPlaceholderDeleted","VersionPlaceholderUpdated"],callback:this.handleVersionPlaceholderNotification,parent: "Version"})
    this.addWSEventListener({eventname:[NotifierConstants.assetModifiedNotification],callback:this.handleProxyUpdatedNotification,parent:"Version"})
    let payload = {params:{assetId: this.fileInfo.asset_id}}
    this.getVersionInfoFromServer(payload).then((data) => {
      this.versionInfo = data.version_info;
      if(data.placeholder_info){
        this.placeholderInfo = data.placeholder_info
      }
    })
  },
  beforeDestroy(){
    this.removeWSEventListener({eventname:"FILE_UPDATED", callback:this.handleFileUpdatedNotification,parent:"Version"});
    this.removeWSEventListener({eventname:"FILE_OUTDATED", callback:this.handleFileOutdatedNotification,parent:"Version"});
    this.removeWSEventListener({eventname:"FILE_DELETED", callback:this.handleFileDeletedNotification,parent:"Version"});
    this.removeWSEventListener({eventname:"VERSION_UPDATED", callback:this.handleVersionUpdatedNotification,parent:"Version"});
    this.removeWSEventListener({eventname:"VERSION_STATE_UPDATED", callback:this.handleVersionStateUpdatedNotification,parent:"Version"});
    this.removeWSEventListener({eventname:["VersionPlaceholderCreated","VersionPlaceholderDeleted","VersionPlaceholderUpdated"],callback:this.handleVersionPlaceholderNotification,parent: "Version"})
    this.removeWSEventListener({eventname:[NotifierConstants.assetModifiedNotification],callback:this.handleProxyUpdatedNotification,parent:"Version"});
  }
}
</script>

<style scoped lang="scss">
$table-row-border: none;
$active-blue: #007bff;
$danger-color: #dc3545;
$none-text-color:#4f4f4f;
$add-button-text-color:#0b7099;
$add-button-text-color-hover:#0193cc;
$add-button-border-color:#b7b228;
$add-button-border-on-hover:#dcd426;
$add-button-backgroud:#1e1e1e;
$active-green-color:#28a745;
$primary-background: #1a1e21;
$border-color: 1px solid #4a4a4a;
$primary-background: #1a1e21;
$secondary-background-color:#15181B;
$bg-color-on-hover: #22272b;
$text-color: #eee;
$dull-text-color: #757575;
$secondary-text-color: #9c9c9c;
$active-blue : #007bff;
$input-field-and-label-font-size:14px;
$input-field-height:38px;
$highlight-font-color:#ff9800;
$scrollbar-thumb-background:#333;
$scrollbar-track-background:#1a1e21;
$scrollbar-thumb-on-hover-background:#555; 
$input-field-padding:.375rem 10px;
$filter-border-color: #5a5a5a;
$filter-bg-color: #2a2a2a;
$learn-about-text-color-hover:#b7b327;
$learn-about-text-color:#9a9620;
$tags-background-color:#282d31;
$svg-color:#666;
$tags-border-color:#363636;
$secondary-border-color: 1px solid #2b2b2b;
$icon-hover:#2c3339;

.btn{
    font-size:14px !important;
    height:100%;
}


.border{
    border: $border-color !important;
}

.activeclass{
    color: $active-blue;
}

ul{
    list-style-type: none;
}

.primary-btn-style{
    text-align: end;
    button{
        height: 38px;
        font-size:14px;
        width: inherit;
    }
    .text-light:hover{
      text-decoration: underline;
    }
}
.secondary-btn-style{
  color:$text-color;
}
.close-icon:hover{
  background: $icon-hover;
  border-radius: 20px;
}
.nav-item{
    color: $dull-text-color !important;
}
.inactive:hover{
  color:$text-color !important;
}
.active{
    background: $primary-background !important;
    color:$active-blue  !important;
    border-bottom: 2px solid $active-blue ;
}
.top-nav-bar{
    text-align: center;
    background: $primary-background;
}

/* width */
  ::-webkit-scrollbar {
    width: 8px;
    height:8px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: $scrollbar-track-background !important;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: $scrollbar-thumb-background !important;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: $bg-color-on-hover !important;
  }

.common-input-field{
    margin-inline-start: 3%;
    display: inline-block;
    width: 96%;
    justify-content: space-between;
    display: inline-block;
    padding: 9px;
    border-radius: 4px;
    background: $primary-background;
    border: $secondary-border-color !important;
    label{
        width: 30%;
        color: $secondary-text-color;
        word-break: break-word;
    }
    input{
        flex:1;
    }
}
.input-text-field{
    height: 44px;
    width: 100% !important;
    padding-inline-start: 2%;
    padding-inline-end:2%;
    overflow: hidden;
}

  .add-border{
    border: $border-color;
  }

  .minMaxTextarea{
    min-height: 38px;
  }

  textarea:focus{
    outline: none;
    bottom: 0px;
    inset-inline-start:0px;
    --saf-0: rgba(var(--sk_highlight,18,100,163),1);
    box-shadow: 0 0 0 1px var(--saf-0),0 0 0 5px #00254E;
    border-radius: 4px;
    border-color: transparent;
    -webkit-appearance: none;
  }

  .dull-the-text{
    color: $dull-text-color;
  }

  ::placeholder {
    color: $dull-text-color !important;
  }

ul,.placeholder-file-name{
    list-style-type: none;
    padding: 0px;
    border: 1px solid #384445;
    border-radius: 10px;
    background: #202729 !important;
    margin: 10px 5px;
    padding: 5px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
    margin-top: 0px;
    li{
        display:inline-flex;
        width: 97%;
        padding:2px;
        .key-style{
            color:$dull-text-color;
            width:17%;
            text-align: end;
        }
        .value-style{
            color: #b6b6b6;
            width: 80%;
            text-align: start;
            margin-inline-start: 11px;
            word-break: break-all;
        }
    }
}

.version-basic-info-wrapper{
    display: flex;
    flex-direction: column;
    padding:5px;
    position: relative;
    margin-bottom: 10px;
    .version-number-tag{
        border: $border-color;
        padding: 5px;
        width: 50px;
        height: 30px;
        font-size: 12px;
        border-radius: 10px;
        display: inline-flex;
        justify-content: center;
        background: #3a6e8b;
        margin: 0px 5px;
    }
    .latest-version-tag{
        border: $border-color;
        padding: 5px;
        width: 100px;
        height: 30px;
        font-size: 12px;
        border-radius: 10px;
        display: inline-flex;
        justify-content: center;
        background: #4d8b3a;
        margin: 0px 5px;
    }
}

.version-basic-info-wrapper:hover{
  border: $border-color;
  border-radius: 10px;
  background: #22272b;
  padding: 4px;
  .actions-on-manage-versions{
    visibility: visible;
    svg{
      margin-inline-end:5px;
    }
  }
}

.actions-on-manage-versions{
  visibility: hidden;
}

.actions-on-manage-versions{
  cursor: pointer;
  position: absolute;
  inset-inline-end: 0px;
  width: auto;
  height: 35px;
  border-radius: 4px;
  top: 4px;
  inset-inline-end: 3px;
  padding: 0px 5px;
  svg{
      margin:2px;
      padding: 4px;
      height: 28px;
      width: 28px;
      border-radius: 4px;
      margin-inline-end: 5px;
      color: #c0c0c0;
  }
  svg:hover{
      background: #fdfeff54;
  }
}

.version-info-display{
  overflow: auto;
  padding-inline-start: 10px;
}

.tag-style{
    font-size:12px!important;
    height: 30px!important;
    display: inline-flex!important;
    margin: 2px!important;
    border: 1px solid $tags-border-color!important;
    border-radius: 10px!important;
    min-width: 50px!important;
    padding: 0!important;
    text-align: center;
    width: auto!important;
    padding-inline-start: 1px!important;
    justify-content: center;
    padding-top: 4px!important;
    background: $tags-background-color;
    span {
        padding: 0px 8px !important;
        margin-inline-start: 0px !important;
        font-size:12px !important;
        border-radius: 15px !important;
        position: relative !important;
        top: 1px !important;
    }
}
.version-placeholder-tag{
  border: $border-color;
  padding: 4px;
  width: 125px;
  height: 30px;
  font-size: 15px;
  border-radius: 10px;
  display: inline-flex;
  justify-content: center;
  background: #d8b913fc;
  margin: 0px 5px;
  color: #000;
}

.upload-progress-bar{
    width: 96%;
    border: 1px solid #4a4a4a;
    border-radius: 10px;
    background: #202729;
    padding: 4px;
    margin: 12px;
    cursor: pointer;
    .edit-upload-info{
        width:8%;
        padding: 5px;
            svg{
                position: relative;
                inset-inline-end: 8px;
            }
    }
    .file-name-with-progress-bar-wrapper{
            display: inline-flex;
            width: 100%;
            padding:6px;
            border-bottom: 1px solid #282727;
            .file-name-wrapper{
                width: 90%;
                display: inline-block;
                .file-name-display{
                      font-size: 16px;
                      white-space: nowrap;
                      width: 98%;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      text-align: initial;
                      position: relative;
                      inset-inline-start:0px;
                      top: 2px;
                }
                .progress-bar-wrapper{
                        display: inline-flex;
                        width: 100%;
                        .progress-percentage-display{
                                font-size: 11px;
                        }
                        .progress{
                            width: 70%;
                            background: #292929;
                            margin-inline-start: 4px;
                            height: 10px;
                            margin-top: 2px;
                            border-radius: 3px;
                        }
                        .progress-speed-display{
                                font-size: 11px;
                                margin-inline-start: 3px;
                                width:64px;
                        }
                }
            }
    }
    .file-upload-status-display-wrapper{
        width:10%;
        .file-upload-status{
            width: 30px;
            height: 30px;
            margin-top: 10px;
        }
    }
}
.file-size-display{
    color: #a2a0a0;
    font-size: 11px;
    width: 55px;
    font-weight: 900;
    position: relative;
    top: 1px;
}

.subaction-styles{
  padding:8px;
}

.subaction-styles:hover{
  background: #22272b !important;
}

.sub-dropdown-item{
  display: block;
  width: 100%;
  padding: 0.25rem 1.5rem;
  clear: both;
  font-weight: 400;
  color: #eee;
  text-align: inherit;
  white-space: nowrap;
  background-color: #15181B;
  border: 0;
}

.sub-dropdown-item:hover{
  text-decoration:none;
}
.upload-placeholder-styles{
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: $dull-text-color;
}

.storage-type-icon{
  margin-inline-end:4px;
  margin-top:2px;
}

.hightlight-icon:hover{
  fill: #fff;
}
</style>